var _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBannerColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.9917,
    y: 0.63125,
    width: 5.13623,
    height: 5.13623,
    rx: 0.65,
    fill: "#F3F3F3",
    stroke: "#C4C4C4",
    strokeWidth: 0.7
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9917,
    y: 7.21719,
    width: 5.13623,
    height: 5.13623,
    rx: 0.65,
    fill: "#F3F3F3",
    stroke: "#C4C4C4",
    strokeWidth: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.9917,
    y: 13.807,
    width: 5.13623,
    height: 4.56278,
    rx: 0.65,
    fill: "#F3F3F3",
    stroke: "#C4C4C4",
    strokeWidth: 0.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.63125,
    width: 10.1909,
    height: 17.7344,
    rx: 0.65,
    fill: "white",
    stroke: "#FFB600",
    strokeWidth: 0.7
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.35,
    y: 0.63125,
    width: 10.1909,
    height: 10.25,
    rx: 0.65,
    fill: "#FFB600",
    fillOpacity: 0.5,
    stroke: "#FFB600",
    strokeWidth: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBannerColumn);
export default __webpack_public_path__ + "static/media/ic-banner-column.b75faed866274a55b3c8a0b1f8fabeae.svg";
export { ForwardRef as ReactComponent };